// extracted by mini-css-extract-plugin
export default {"personContainer":"People_personContainer__-3qIn","peopleWrapper":"People_peopleWrapper__n8avP","titleWrapper":"People_titleWrapper__NyuuN"};